import React from 'react';
import styles from './styles/styles.module.css';
import { useDispatch, useSelector } from 'react-redux';
import {
  setChecklistTab,
  setInventoryTab,
  setReportsTab,
  setSetupTab,
  setTrackerTab,
} from '../../Redux/slices/tabSlice';

interface TabInterface {
  tabType: 'SETUP' | 'REPORTS' | 'INVENTORIES' | 'CHECKLISTS' | 'TRACKERS';
}

const TabsLong: React.FC<TabInterface> = ({ tabType }) => {
  const dispatch = useDispatch();
  const {
    setupTab,
    reportsTab,
    reportsTabItems,
    setupTabItems,
    inventoryTab,
    inventoryTabItems,
    checklistTab,
    checklistTabItems,
    trackerTab,
    trackerTabItems,
  } = useSelector((state: any) => state.tab);
  const { userType } = useSelector((state: any) => state.user);

  function returnSelectedTabState() {
    switch (tabType) {
      case 'SETUP':
        return setupTab;
      case 'REPORTS':
        return reportsTab;
      case 'INVENTORIES':
        return inventoryTab;
      case 'CHECKLISTS':
        return checklistTab;
      case 'TRACKERS':
        return trackerTab;
    }
  }

  function selectionSetter(payload: number) {
    switch (tabType) {
      case 'SETUP':
        return setSetupTab(payload);
      case 'REPORTS':
        return setReportsTab(payload);
      case 'INVENTORIES':
        return setInventoryTab(payload);
      case 'CHECKLISTS':
        return setChecklistTab(payload);
      case 'TRACKERS':
        return setTrackerTab(payload);
    }
  }

  function returnTabArray() {
    let tabItems = [];

    if (tabType === 'SETUP') {
      tabItems = setupTabItems;
    } else if (tabType === 'REPORTS') {
      tabItems = reportsTabItems;
    } else if (tabType === 'INVENTORIES') {
      tabItems = inventoryTabItems;
    } else if (tabType === 'CHECKLISTS') {
      tabItems = checklistTabItems;
    } else if (tabType === 'TRACKERS') {
      tabItems = trackerTabItems;
    }

    //filters out tabs that are only for hyper users.
    if (tabType === 'SETUP' && userType !== 'HYPER_ADMIN') {
      tabItems = setupTabItems.filter(
        (item: string) => item.toLowerCase() !== 'add company'
      );
    }
    return tabItems;
  }

  return (
    <div className={styles.wrapper}>
      {returnTabArray().map((item: string, index: number) => {
        return (
          <div
            key={item}
            onClick={() => dispatch(selectionSetter(index))}
            className={
              returnSelectedTabState() === index
                ? styles.tabContainerHighlight
                : styles.tabContainer
            }
          >
            {' '}
            <p className={styles.tabItem} key={item + '_text'}>
              {item}
            </p>{' '}
          </div>
        );
      })}
    </div>
  );
};

export default TabsLong;
